import type { VoidFunctionComponent } from 'react';
import ContentLoader from 'react-content-loader';

const RemediationLoading: VoidFunctionComponent = () => (
  <ContentLoader width="100%" height="120px">
    <rect x="0" y="2" rx="3" ry="3" width="85px" height="18" />
    <rect x="0" y="34" rx="3" ry="3" width="100%" height="24" />
    <rect x="0" y="68" rx="3" ry="3" width="100%" height="24" />
  </ContentLoader>
);

export default RemediationLoading;
